// extracted by mini-css-extract-plugin
module.exports = {"button":"ArtistPillButton_button__3v2C4","image":"ArtistPillButton_image__3CTYb"};